<template>
  <zen-one
    :showuserinfo="false"
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >

    <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess" >

      <z-page title="Butiran Pembayar">

           <div class="message-box">
            <w-transition-fade>
              <w-alert
                class="my0 text-light"
                v-if="form.submitted"
                success
                no-border>
                The form is valid, ready to send it!
              </w-alert>

              <w-alert
                class="my0 text-light"
                v-else-if="form.valid === false"
                error
                no-border>
                Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
              </w-alert>
            </w-transition-fade>
          </div>

          <w-flex class="mt3">
              <div class="xs6 mr3">
                  <w-input
                  required
                  label="ID Pembayar" v-model="form.no_id">
                  </w-input>
              </div>
              <div class="xs6">
                  <w-input
                  required
                  label="Nama Pembayar" v-model="form.nama">
                  </w-input>
              </div>
          </w-flex>


          <w-flex class="mt3">
              <div class="xs4 mr3">
                  No. Daftar Mel : <br>{{no_rujukan}}
              </div>
              <div class="xs4 mr3">
                  Tarikh Daftar : <br>{{$zutil.dateformat(tarikh_sedia)}}
              </div>
              <div class="xs4">
                  Status Bayaran : <br>{{form.status_mel}}
              </div>
          </w-flex>
      </z-page>
    </w-form>
    <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="submitTerimaanPukal" @success="onSuccess">
            <z-page title="Butiran Bayaran" >
                  <w-card bg-color="" class="">
                    <w-flex justify-space-between class="mb4">
                        <div class="xs4">
                            <!-- <w-input label="No Rujukan" v-model="no_rujukan" name="no_rujukan" /> -->
                        </div>
                        <!-- <div class="xs4">
                            <w-button class="ml1 " @click="Detail()">
                                <w-icon>fal fa-search</w-icon>&nbsp;Cari
                            </w-button>
                        </div> -->
                    </w-flex>
                  </w-card>
                  <w-flex justify-center align-center class="table-hardcode mt3">
                     <div class="w-card__content content-hardcode">
                        <table class="table-dashboard" width="100%">
                            <thead>
                                <tr>
                                    <td>Jabatan</td>
                                    <td>No. Rujukan</td>
                                    <td>Nama</td>
                                    <td>Kod Akaun</td>
                                    <td>Butiran Bayaran</td>
                                    <td>Amaun (RM)</td>
                                    <td>Amaun Bayar (RM)</td>
                                    <td></td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="dat in data_bayaran">
                                    <td>
                                      {{dat.jabatan_keterangan }}
                                    </td>
                                    <td>
                                      {{dat.no_rujukan}}
                                    </td>
                                    <td>
                                      {{dat.profil_nama}}
                                    </td>
                                    <td>
                                      {{dat.akaun_id}}
                                    </td>
                                    <td>
                                      {{dat.butiran_bayaran}}
                                    </td>
                                    <td>
                                      {{dat.amaun_cukai}}
                                    </td>
                                    <td>
                                        <w-input class="mb4" label="" type="number" v-model="dat.amaun_bayar"  v-on:keyup="cekAmaunBayaran(dt)" v-on:click="cekAmaunBayaran(dt)" />
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="6" align="right">JUMLAH</td>
                                    <td align="right">{{form.amaun}}</td>
                                    <td align="center"></td>
                                </tr>
                                <tr>
                                    <td colspan="6" align="right">JUMLAH DIBAYAR</td>
                                    <td align="right">{{}}</td>
                                    <td align="center"></td>
                                </tr>
                            </tbody>
                        </table>
                        <w-flex class="mt3" wrap align-center justify-end>
                            <div class="spacer" />
                            <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                                <w-icon dark tile class="mr2">fal fa-save</w-icon> Simpan
                            </w-button>
                        </w-flex>
                      </div>
                  </w-flex>
             </z-page>
        </w-form>
  </zen-one>
</template>

<script>

import ZResource from '@/Modules/z-resource-service'

export default {
extends: ZResource,
components: {
},
props: {
    no_rujukan: [String, Object],
    tarikh_sedia: [String, Object],
    lkp_terimaan_pukal_status_id: [String, Object],
    profil_id: [String, Object],
    lkp_tindakan_id: [String, Object],
    // id_terimaan_pukal_butiran_data: [Array,Object],

},
data() {
    return {

    resourceurl: this.service_kutipan+'terimaan_pukal'+'?no_rujukan='+this.no_rujukan+'&profil_id='+this.profil_id,

  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0,
    nama: '',
    no_id: '',
    status_mel: '',
    data_bayaran: []
  },
  crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Kutipan', route: '/kutipan' },
        { label: 'Mel', route: '/mel' },
        { label: 'Butiran', route: '/kutipan/mel' },
  ],
  showCard: false,
  data_bayaran: []
}},
methods: {

  onSuccess () {
    setTimeout(() => (this.form.sent = true), 2000)
    // this.$inertia.visit(window.route('kutipan.mel.index'));
    this.$inertia.visit(this.$page.url)
  },
  onValidate () {
    this.form.sent = false
    this.form.submitted = this.form.errorsCount === 0
  },
  profilDetail() {
      this.$zcomm.get(this.service_kutipan+'profil/'+this.profil_id)
      .then(res => {
            this.form.nama = res.nama;
            this.form.no_id = res.no_id;
        });
    },
  terimaanPukalDetail() {
      this.$zcomm.get(this.service_kutipan+'lookup/detail_status_mel/'+this.lkp_terimaan_pukal_status_id)
      .then(res => {
            this.form.status_mel = res.keterangan;
        });
    },

  submitTerimaanPukal(){
    //   alert(this.data_bayaran);
        this.form.data_bayaran = this.data_bayaran;
        this.$zcomm.update(this.service_kutipan+'terimaan_pukal/' + 4, this.form)
        .then(res => {
            //update displayed record
            this.mapreturneddata(res)

          if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }

            // this.$inertia.visit(this.$page.url)
        })
        .catch(err => {

        })
        .finally(() => {
        });
    },

    // submitTerimaanPukal(){
    //     this.form.data_bayaran = this.data_bayaran;
    //     // console.log(this.form.data_bayaran);
    //     // console.table(this.form);
    //     // this.form.id = this.data.id;
    //     // this.data.lkp_tindakan_id = 2
    //     // this.data.amaun = this.data.amaun_bayar
    //     // this.$zcomm.post(this.service_kutipan+'api/terimaan_pukal/kemaskini', this.form)
    //     // console.log(this.form)
    //     // this.$zcomm.post(this.service_kutipan+'api/terimaan_pukal/kemaskini', this.form)
    //     this.$zcomm.update(this.service_kutipan+'api/terimaan_pukal/' + 4, this.form)
    //     .then(res => {
    //         //update displayed record
    //         this.mapreturneddata(res)

    //       if (typeof this.onAfterEdit === "function") {
    //           this.onAfterEdit()
    //         }

    //         this.$inertia.visit(this.$page.url)
    //     })
    //     .catch(err => {

    //     })
    //     .finally(() => {
    //     });
    // },


  akaunDetail() {
            this.$zcomm.get(this.service_kutipan+'terimaan_pukal/senarai'+'?no_rujukan='+this.no_rujukan+'&profil_id='+this.profil_id+'&lkp_terimaan_pukal_status_id='+this.lkp_terimaan_pukal_status_id+'&tarikh_sedia='+this.tarikh_sedia).then(res => {
            //  console.log(res.data[0].id)
                this.data_bayaran = res.data;

                // this.data.id = res.data.id;

            });
   },


  cekAmaunBayaran(){
          this.form.amaun = 0;
          for (var i in this.data_bayaran) {
            this.form.amaun = this.form.amaun + parseFloat(this.data_bayaran[i].amaun_bayar);
            }
   },

},
watch: {


},
mounted() {
                this.akaunDetail();
                this.profilDetail();
                this.terimaanPukalDetail();


},
}

</script>

<style>


</style>
